import * as selectors from "./selectors";
import * as events from "./events";

export const REPORT_DETAIL_STORE_INSTANCE = {
  selectors,
  events,
};

export type {
  SectionListRecordsItem,
  RelacoesSectionListItem,
  UpdateFnPromise,
  ReportDetailState,
  ReportDetailMutations,
} from "./interface";